import { Flex, Spinner } from '@chakra-ui/react'

/**
 * Shown while the router resolves a lazy route before anything is mounted —
 * including the very first navigation, where no shell exists yet.
 */
const RouteFallback = () => (
  <Flex
    minHeight="100dvh"
    align="center"
    justify="center"
    bg="bg.canvas"
    role="status"
    aria-label="Loading"
  >
    <Spinner size="sm" color="fg.subtle" borderWidth="2px" />
  </Flex>
)

export default RouteFallback
